import moment from 'moment';

import { cn, ia, iaRa } from 'lib/helpers/utility';

import TreatmentPlanStatus from 'components/practice/charts/Overview/widgets/components/TreatmentPlan/TreatmentPlanStatus';
import {
  CPT_CODE_OPTIONS,
  ICD_CODE_OPTIONS,
  PATIENT_OPTIONS,
  PROVIDER_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';

export const DEFAULT_FILTERS = {
  provider: { ...PROVIDER_OPTIONS, allowed_operators: ['is', 'is any of', 'is not'] },
  patient: { ...PATIENT_OPTIONS, allowed_operators: ['is', 'is any of', 'is not'] },
  cpt: { ...CPT_CODE_OPTIONS, allowed_operators: ['is', 'is any of', 'is not'] },
  icd: { ...ICD_CODE_OPTIONS, allowed_operators: ['is', 'is any of', 'is not'] }
};

export const formatFilters = (mapValues) => {
  const formattedFilters = {};
  Object.keys(mapValues).forEach((key) => {
    const filter = mapValues[key];
    if (filter?.values) {
      formattedFilters[key] = iaRa(filter?.values).map((v) => v?.value);
    } else {
      formattedFilters[key] = filter;
    }
  });
  return formattedFilters;
};

export const treatmentPlanCols = [
  {
    field: 'treatment_frequency_date.startDate',
    headerName: 'Start Date'
  },
  {
    field: 'treatment_frequency_date.endDate',
    headerName: 'End Date (Review Date)',
    cellRenderer: ({ value, data }) => {
      const endDateMoment = moment(data.treatment_frequency_date?.endDate, 'MM/DD/YYYY');
      const currentDate = moment();
      const isExpired = endDateMoment.isBefore(currentDate, 'day');

      return <p className={cn(isExpired && '!text-danger-500')}> {value}</p> || 'N/A';
    }
  },
  {
    field: 'icd10',
    headerName: 'ICD Codes',
    valueFormatter: ({ value: icd10 }) => (ia(icd10) ? icd10.map((i) => i?.value).join(', ') : '-')
  },
  {
    field: 'cpt_codes',
    headerName: 'CPT Codes',
    valueFormatter: ({ value }) =>
      ia(value) ? value?.map((i) => i?.procedure_code).join(', ') : 'N/A'
  },
  {
    field: 'createdBy.fullName',
    headerName: 'Created By',
    valueFormatter: ({ value }) => (!!value ? value : 'N/A')
  },
  {
    field: 'status',
    headerName: 'Status',
    cellClass: 'no-border',
    cellRenderer: (params) => {
      if (params.node.group || !params?.data) {
        return null;
      }
      return (
        <div className="flex h-full items-center justify-center">
          <TreatmentPlanStatus
            signers={params?.data?.document_sign}
            classNames="flex min-w-[80px] justify-center items-center"
          />
        </div>
      );
    },
    resizable: false
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: Actions,
    maxWidth: 100,
    pinned: 'right'
  }
];
